import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { ImageOff, Pencil, Plus } from 'lucide-react';
import { Panel, Vacio } from '../../bodas/admin/comunes';
import InterruptorVisible from './InterruptorVisible';
import { adminApi, cop, errorApi, imgSrc } from './tiendaAdminApi';

const TarjetaAdmin = ({ p, onEditar, onCambio }) => {
  const opciones = p.grupos.filter(g => g.tipo !== 'texto').reduce((n, g) => n + g.opciones.length, 0);
  return (
    <Panel className="flex flex-col overflow-hidden" testId={`tienda-admin-producto-${p.id}`}>
      <div className="aspect-[4/3] bg-slate-100">
        {p.imagen_url ? <img src={imgSrc(p.imagen_url)} alt={p.nombre} className="h-full w-full object-contain p-4" /> : <ImageOff className="m-auto h-full w-10 text-slate-300" />}
      </div>
      <div className="flex flex-1 flex-col gap-3 p-4">
        <div>
          <p className="font-semibold text-slate-800">{p.nombre}</p>
          <p className="text-sm text-slate-500">{cop(p.precio)} COP · {p.grupos.length} grupos · {opciones} opciones</p>
        </div>
        <InterruptorVisible producto={p} onCambio={onCambio} />
        <button onClick={() => onEditar(p.id)} className="mt-auto inline-flex items-center justify-center gap-2 rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50" data-testid={`tienda-editar-${p.id}`}>
          <Pencil className="h-4 w-4" />Editar producto
        </button>
      </div>
    </Panel>
  );
};

export default function ListaProductosAdmin({ onEditar }) {
  const [productos, setProductos] = useState(null);

  useEffect(() => {
    adminApi.productos().then(r => setProductos(r.data.productos)).catch(e => { setProductos([]); toast.error(errorApi(e, 'No se pudieron cargar los productos')); });
  }, []);

  const actualizar = (nuevo) => setProductos(lista => lista.map(p => (p.id === nuevo.id ? nuevo : p)));

  return (
    <div className="space-y-4" data-testid="tienda-admin-lista">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-slate-600">Los productos nuevos quedan <b>ocultos</b> hasta que actives «Visible para clientes».</p>
        <button onClick={() => onEditar('nuevo')} className="inline-flex items-center gap-2 rounded-lg bg-slate-800 px-4 py-2 font-medium text-white transition hover:bg-slate-700" data-testid="tienda-nuevo-producto">
          <Plus className="h-4 w-4" />Nuevo producto
        </button>
      </div>
      {productos === null && <div className="h-48 animate-pulse rounded-xl bg-slate-200" />}
      {productos?.length === 0 && <Panel><Vacio testId="tienda-admin-vacia">Aún no hay productos. Crea el primero.</Vacio></Panel>}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {productos?.map(p => <TarjetaAdmin key={p.id} p={p} onEditar={onEditar} onCambio={actualizar} />)}
      </div>
    </div>
  );
}
